import { createContext, type ChangeEvent, useContext } from "react";

export type ChipSelectValue = string | string[] | null;

export interface ChipSelectContextValue {
  value: ChipSelectValue;
  multiple: boolean;
  name?: string;
  disabled: boolean;
  allowEmpty: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>, optionValue: string) => void;
}

export const ChipSelectContext = createContext<ChipSelectContextValue | null>(null);

export const useChipSelectContext = () => {
  const context = useContext(ChipSelectContext);
  if (!context) {
    throw new Error("ChipSelect.Option must be used within a ChipSelect");
  }
  return context;
};
